import React from "react";
import { usePageContext } from "vike-react/usePageContext";
import { BannerAd } from "@/components/ads/BannerAd";
import { ArticleBody } from "@/components/articles/ArticleBody";
import { ArticleEndActions } from "@/components/articles/ArticleEndActions";
import { ArticleHero } from "@/components/articles/ArticleHero";
import { ArticleSources } from "@/components/articles/ArticleSources";
import { ArticleTableOfContents } from "@/components/articles/ArticleTableOfContents";
import { Breadcrumb } from "@/components/parts/Breadcrumb";
import { getArticleBreadcrumb, toViewBreadcrumbItems } from "@/lib/Breadcrumb";
import type { PageData } from "@/pages/articles/@slug/+onBeforeRender";

const Page: React.FC = () => {
  const pageContext = usePageContext();
  const {
    article,
    publicationStatus,
    headings,
    products,
    sidebarBanners,
    sidebarBooks,
    url,
  } = pageContext.data as PageData;

  return (
    <div className="bg-canvas">
      <div className="mx-auto max-w-6xl px-4 pt-4">
        <Breadcrumb
          items={toViewBreadcrumbItems(
            getArticleBreadcrumb(article.title, url),
          )}
        />
      </div>
      <ArticleHero
        category={article.category}
        title={article.title}
        publishedAt={article.publishedAt}
        updatedAt={article.updatedAt}
        tags={article.tags}
        publicationStatus={publicationStatus}
        imageUrl={article.ogImageUrl}
      />
      <div className="mx-auto max-w-6xl px-4 py-8 lg:grid lg:grid-cols-[minmax(0,1fr)_17rem] lg:gap-8">
        <div>
          <div className="rounded-2xl border border-primary-100 bg-white px-5 py-8 shadow-sm md:px-10 md:py-10">
            <ArticleBody body={article.body} products={products} />
            <ArticleEndActions
              slug={article.slug}
              title={article.title}
              url={url}
            />
          </div>
        </div>
        <aside className="mt-10 lg:mt-0">
          <div className="space-y-6 lg:sticky lg:top-24 lg:max-h-[calc(100vh-7rem)] lg:overflow-y-auto">
            <div className="hidden lg:block">
              <ArticleTableOfContents headings={headings} />
            </div>
            <BannerAd banners={sidebarBanners} books={sidebarBooks} />
            <ArticleSources sources={article.sources} />
          </div>
        </aside>
      </div>
    </div>
  );
};

export default Page;
